import Layout from "../../../components/layout/Layout";
import * as P from "../../../components/customizing/print/Print.styles";
import { Fragment } from "react";
import { SeoMeta } from "@/utils/seo/SeoMeta";
import {
  productArr,
  progressArr,
  strengthArr,
  strengthSlideArr,
} from "@components/customizing/print/Print.data";
import { Swiper, SwiperSlide } from "swiper/react";
import { PrintDesignService } from "@components/customizing/print/PrintDesignService";
import { PrintTab } from "@components/customizing/print/printTab/PrintTab";
import Image from "next/image";
import { useRouter } from "next/router";
import { OutlineBtn } from "../../../components/customizing/print/Print.styles";

const CustomizingPrintPage = () => {
  const router = useRouter();
  return (
    <>
      <Layout
        parent={"홈"}
        sub={"소량인쇄"}
        pageTitle={SeoMeta.smallPrintService.title}
        pageDesc={SeoMeta.smallPrintService.description}
        pageKeyword={SeoMeta.smallPrintService.keywords}
      >
        <PrintTab />
        <Image
          src="/img/print/print_01.png"
          alt="소량인쇄_상품소개"
          width={1900}
          height={367}
          style={{ width: "100%", height: "auto", minWidth: "300px" }}
        />
        <div className="container">
          <P.NormalTitle>
            <strong>소량인쇄, </strong> 이런 분들께 추천드립니다.
          </P.NormalTitle>
          <P.StrengthWarpper>
            {strengthArr.map((item, index) => (
              <P.StrengthItem key={index}>
                <P.HighlightText>{item.title}</P.HighlightText>
                <P.StrengthImage src={item.img} alt={`strength-${index}`} />
                <P.ArrowText>{item.desc.join("\n")}</P.ArrowText>
                <P.NormalText>{item.memo.join("\n")}</P.NormalText>
              </P.StrengthItem>
            ))}
          </P.StrengthWarpper>
        </div>
        <P.StrengthSliderWrapper>
          <div className="strengthSection">
            <P.StrengthPC className="container">
              <h6>
                칼렛스토어의 <strong>소량인쇄</strong>가 특별한 이유!
              </h6>
              <div className="strengthGrid">
                {strengthSlideArr.map((str, idx) => (
                  <div className="content" key={idx}>
                    <img src={str.img} />
                    <div className="desc">
                      <h6>{str.title}</h6>
                      <span>{str.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </P.StrengthPC>
          </div>
          <div className="container swiperSection">
            <Swiper
              navigation={{
                prevEl: ".custom_prev_i1",
                nextEl: ".custom_next_i1",
              }}
              pagination={{ clickable: true, el: ".swiper-pagination" }}
            >
              {strengthSlideArr.map((str, idx) => (
                <SwiperSlide key={idx}>
                  <P.StrengthSlide>
                    <h6>
                      칼렛스토어의 <strong>소량인쇄</strong>가 특별한 이유!
                    </h6>
                    <div className="content">
                      <img src={str.img} />
                      <div className="desc">
                        <h6>{str.title}</h6>
                        <span>{str.desc}</span>
                      </div>
                    </div>
                  </P.StrengthSlide>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="slider-arrow">
              <span className="slider-btn slider-prev slick-arrow custom_prev_i1">
                <i className="fi-rs-angle-left"></i>
              </span>
              <span className="slider-btn slider-next slick-arrow custom_next_i1">
                <i className="fi-rs-angle-right"></i>
              </span>
            </div>
            <div className="swiper-pagination" />
          </div>
        </P.StrengthSliderWrapper>
        {/*소량인쇄 가능 상품*/}
        <P.ProductWrapper>
          <div className="container">
            <P.NormalTitle>
              <strong>소량인쇄 가능 상품</strong>
            </P.NormalTitle>
            <P.ProductGrid>
              {productArr.map((item, index) => (
                <P.ProductItem key={`${index}_product`}>
                  <P.ProductImage src={item.img} alt={item.desc} />
                  <P.ProductDesc>{item.title}</P.ProductDesc>
                </P.ProductItem>
              ))}
            </P.ProductGrid>
            <P.OutlineBtn
              className={"btn mt-50"}
              onClick={() => router.push("/customizing/print/product/")}
            >
              소량인쇄 상품 선택하기
            </P.OutlineBtn>
          </div>
        </P.ProductWrapper>

        {/*소량인쇄 진행 과정*/}
        <P.ProcessWrapper>
          <div className="container">
            <P.NormalTitle>
              <strong>소량인쇄 진행 과정</strong>
            </P.NormalTitle>
            <P.ProcessGrid>
              {progressArr.map((item, index) => (
                <Fragment key={index}>
                  <P.ProcessItem>
                    <P.ProcessImage src={item.img} alt={item.title} />
                    <P.ProcessDesc>{item.title}</P.ProcessDesc>
                  </P.ProcessItem>
                  {index !== progressArr.length - 1 && (
                    <P.Arrow>
                      <i className="fi-rs-angle-right"></i>
                    </P.Arrow>
                  )}
                </Fragment>
              ))}
            </P.ProcessGrid>
          </div>
        </P.ProcessWrapper>

        <div className="container">
          <P.NormalTitle>
            <strong>제작 사례</strong>
          </P.NormalTitle>
          <Image
            src="/img/print/print_06.png"
            alt="소량인쇄_상품소개"
            width={1120}
            height={540}
            style={{ width: "100%", height: "auto" }}
          />
          <P.CaseButton>
            <P.OutlineBtn
              className="btn"
              onClick={() => router.push("/customizing/print/guide/")}
            >
              제작 가이드 보기
            </P.OutlineBtn>
          </P.CaseButton>
        </div>

        <PrintDesignService />
      </Layout>
    </>
  );
};

export default CustomizingPrintPage;
